import React from "react";
import Star from "../Images/Star.png";
import StarB from "../Images/StarB.png";
import "../CSS/cross.css";

const Cross = () => {
  return (
    <div className="relative w-full top-[-100px] md:h-[220px] flex items-center justify-center bg-gradient">
      {/* First Scrolling Div - Moves Left */}
      <div className="absolute bg-[#432DD7] md:h-[132px] w-[98.8vw] top-0 md:rotate-[-8deg] rotate-[10deg] z-50  mask-gradient">
        <div className="scroll-container">
          <div className="scrolling-text-left text-white ">
            <RepeatedText starImage={Star} />
            <RepeatedText starImage={Star} />
          </div>
        </div>
      </div>
      .
      <div className=" absolute bg-[#432DD733] border border-[#432DD7] md:h-[132px] w-[98.9vw] top-0 md:rotate-[10deg] rotate-[-10deg]  mask-gradient">
        <div className="scroll-container">
          <div className="scrolling-text-left text-[#432DD7] ">
            <RepeatedText starImage={StarB} />
            <RepeatedText starImage={StarB} />
          </div>
        </div>
      </div>
    </div>
  );
};

// Reusable text component with different star images
const RepeatedText = ({ starImage }) => (
  <div className="flex items-center md:mt-6">
    {[...Array(100)].map((_, i) => (
      <div
        key={i}
        className="flex items-center px-12  font-bold md:text-[50px] items-center text-center"
      >
        <span>Software Development</span>
        &nbsp;
        <img
          src={starImage}
          alt="star"
          className="md:h-10 h-5 drop-shadow-lg glow-effect"
        />{" "}
        &nbsp;
        <span>AI Development</span>
        &nbsp;
        <img
          src={starImage}
          alt="star"
          className="md:h-10 h-5 drop-shadow-lg glow-effect"
        />
      </div>
    ))}
  </div>
);

export default Cross;
